//
import { ItemModel } from '@/models'

/**
 *
 */
const create = async function(data) {
    //
    try {
        //
        const item = new ItemModel(data),
            response = await item.save()
        return response
    } catch (error) {
        return error.response
    }
}

//
export default create
